import React from "react";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-wrapper">
      <div className="privacy-section header">
        <h2>Privacy Policy</h2>

        <p>
          At <strong>Clota Technology</strong>, we are committed to protecting
          your personal data and ensuring transparency in how we use it. This
          Privacy Policy explains how we handle your information when you engage
          with our website or services.
        </p>
      </div>

      <div className="privacy-section">
        <h4>1. Information We Collect</h4>
        <p>We collect data to deliver better service and support, including:</p>
        <ul>
          <li>Basic contact details (name, email, phone)</li>
          <li>Project-related files and technical specifications</li>
          <li>Website usage information (via cookies or analytics tools)</li>
        </ul>
      </div>

      <div className="privacy-section">
        <h4>2. How We Use Your Data</h4>
        <p>Your information helps us to:</p>
        <ul>
          <li>Respond to your inquiries and manage projects</li>
          <li>Deliver web development or database solutions</li>
          <li>Improve user experience and site functionality</li>
        </ul>
      </div>

      <div className="privacy-section">
        <h4>3. Data Confidentiality</h4>
        <p>
          All project and personal data is treated as confidential. We never
          share or disclose your data without your consent, except as required
          by law.
        </p>
      </div>

      <div className="privacy-section">
        <h4>4. Security Measures</h4>
        <p>
          We use industry-standard practices to safeguard your information.
          While no system is 100% secure, we take all reasonable steps to
          prevent unauthorized access.
        </p>
      </div>

      <div className="privacy-section">
        <h4>5. Use of Cookies</h4>
        <p>
          Our website may use cookies to enhance functionality and performance.
          You can disable them through your browser settings if you prefer.
        </p>
      </div>

      <div className="privacy-section">
        <h4>6. Third-Party Tools</h4>
        <p>
          We may use trusted third-party services (like payment gateways or
          analytics). These providers follow strict privacy standards.
        </p>
      </div>

      <div className="privacy-section">
        <h4>7. Your Rights</h4>
        <p>
          You have the right to access, correct, or delete your personal
          information. For any data requests, please contact us directly.
        </p>
      </div>

      <div className="privacy-section">
        <h4>8. Policy Updates</h4>
        <p>
          We may update this policy occasionally. All changes will be posted on
          this page with the updated date.
        </p>
      </div>

      <div className="privacy-section contact">
        <h4>📬 Contact Us</h4>
        <p>
          If you have any questions about this Privacy Policy or how we manage
          data, please get in touch:
        </p>
        <p>
          <strong>Clota Technology</strong>
        </p>
        <p>Email: support@clotatechnology.com</p>
        <p>Phone: +91 9490384177</p>
        <p>Website: www.clotatech.com</p>
      </div>
    </div>
  );
}
